{
  "name": "pointee",
  "version": "1.71.0-13590",
  "scripts": {
    "ng": "ng",
    "start": "ng serve --host=127.0.0.1",
    "build-all": "ng build --stats-json --configuration production",
    "build-all-dev": "ng build --stats-json --configuration development",
    "check": "ngc -p tsconfig.json --noEmit",
    "test": "ng test",
    "test-ci": "ng test --watch false --progress false --browsers ChromeHeadlessCI",
    "lint": "ng lint",
    "e2e": "ng e2e",
    "e2e-playwright": "playwright test",
    "e2e-playwright-ui": "playwright test --ui",
    "e2e-playwright-headed": "playwright test --headed",
    "e2e-playwright-debug": "playwright test --debug",
    "generate-icons": "svgo -r --pretty -f ./src/assets/svg && svg-generator && node scripts/clean-svg-comments.js",
    "find-unused-icons": "node scripts/find-unused-icons.js",
    "security-check": "node scripts/generate-security-report.js && npm audit && snyk test",
    "security-fix": "npm audit fix",
    "postinstall": "patch-package"
  },
  "private": true,
  "svgGenerator": {
    "srcPath": "./src/assets/svg",
    "outputPath": "./src/app/svg",
    "svgoConfig": {
      "plugins": [
        "cleanupAttrs",
        "removeDimensions"
      ]
    }
  },
  "dependencies": {
    "@angular/animations": "^20.3.16",
    "@angular/cdk": "^20.2.8",
    "@angular/common": "^20.3.16",
    "@angular/compiler": "^20.3.16",
    "@angular/core": "^20.3.16",
    "@angular/forms": "^20.3.16",
    "@angular/localize": "^20.3.16",
    "@angular/material": "^20.2.8",
    "@angular/material-luxon-adapter": "^20.2.8",
    "@angular/platform-browser": "^20.3.16",
    "@angular/platform-browser-dynamic": "^20.3.16",
    "@angular/router": "^20.3.16",
    "@auth0/angular-jwt": "^5.2.0",
    "@azure/msal-browser": "^3.20.0",
    "@bpmn-io/properties-panel": "^3.30.0",
    "@ctrl/ngx-codemirror": "^7.0.0",
    "@fontsource/roboto": "^5.0.14",
    "@fullcalendar/angular": "^6.1.17",
    "@fullcalendar/core": "^6.1.17",
    "@fullcalendar/daygrid": "^6.1.17",
    "@fullcalendar/interaction": "^6.1.17",
    "@fullcalendar/luxon3": "^6.1.17",
    "@fullcalendar/timegrid": "^6.1.17",
    "@hpcc-js/wasm-graphviz": "^1.0.3",
    "@logscl/ng2-tooltip-directive": "^20.0.0",
    "@microsoft/applicationinsights-web": "^3.3.1",
    "@microsoft/signalr": "^8.0.7",
    "@ng-bootstrap/ng-bootstrap": "^19.0.1",
    "@ngneat/svg-icon": "^8.0.0",
    "@ngrx/component": "^20.0.1",
    "@popperjs/core": "^2.11.8",
    "ag-grid-angular": "^33.3.2",
    "ag-grid-community": "^33.3.2",
    "bootstrap": "^5.3.7",
    "bpmn-js": "^18.6.2",
    "bpmn-js-properties-panel": "^5.37.0",
    "chart.js": "^4.5.0",
    "chartjs-adapter-luxon": "^1.3.1",
    "chartjs-chart-matrix": "^3.0.0",
    "chartjs-plugin-annotation": "^3.1.0",
    "chartjs-plugin-datalabels": "^2.2.0",
    "chartjs-plugin-zoom": "^2.2.0",
    "codemirror": "^5.65.15",
    "diagram-js-grid": "^1.1.0",
    "flag-icons": "^7.2.3",
    "include-media": "^2.0.0",
    "luxon": "^3.7.2",
    "ml-regression-simple-linear": "^3.0.1",
    "ng-multiselect-dropdown": "^1.0.0",
    "ng-table-virtual-scroll": "^1.6.1",
    "ngx-cookie-service": "^20.0.1",
    "ngx-file-drop": "^16.0.0",
    "ngx-mask": "^20.0.3",
    "ngx-mat-select-search": "^8.0.2",
    "rxjs": "^7.8.1",
    "save-svg-as-png": "^1.4.17",
    "stacktrace-js": "^2.0.2",
    "svg-pan-zoom": "^3.6.2",
    "sweetalert2": "^11.23.0",
    "timelines-chart": "2.14.2",
    "uuid": "^13.0.0",
    "zone.js": "~0.15.1"
  },
  "devDependencies": {
    "@angular-devkit/build-angular": "^20.3.5",
    "@angular/cli": "^20.3.5",
    "@angular/compiler-cli": "^20.3.16",
    "@angular/language-service": "^20.3.16",
    "@ngneat/svg-generator": "^7.0.3",
    "@playwright/test": "^1.55.0",
    "@stylistic/eslint-plugin": "^5.3.1",
    "@types/jasmine": "^5.1.4",
    "@types/luxon": "^3.7.1",
    "@types/node": "^22.2.0",
    "@types/uuid": "^10.0.0",
    "angular-eslint": "20.3.0",
    "dotenv": "^17.2.2",
    "eslint": "^9.35.0",
    "eslint-plugin-only-warn": "^1.1.0",
    "glob": "^11.0.0",
    "jasmine-core": "~5.2.0",
    "jasmine-spec-reporter": "~7.0.0",
    "karma": "^6.4.4",
    "karma-chrome-launcher": "^3.2.0",
    "karma-coverage": "^2.2.1",
    "karma-jasmine": "^5.1.0",
    "karma-jasmine-html-reporter": "^2.1.0",
    "karma-junit-reporter": "^2.0.1",
    "patch-package": "^8.0.1",
    "prettier": "^3.6.2",
    "sass": "^1.92.1",
    "svgo": "^4.0.0",
    "ts-node": "~10.9.2",
    "typescript": "5.8.3",
    "typescript-eslint": "8.44.0"
  },
  "overrides": {
    "@modelcontextprotocol/sdk": "^1.26.0"
  }
}
